import { render, staticRenderFns } from "./NoteTab.vue?vue&type=template&id=02855309&scoped=true&"
import script from "./NoteTab.vue?vue&type=script&lang=js&"
export * from "./NoteTab.vue?vue&type=script&lang=js&"
import style0 from "./NoteTab.vue?vue&type=style&index=0&id=02855309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02855309",
  null
  
)

export default component.exports